<template>
  <div v-loading="loading">
    <div class='content'>
      <div class="s_wrapper">
        <el-input class="s_input" placeholder="请输入项目名称" suffix-icon="el-icon-search" v-model="projectName" clearable
          @change="onSearch"></el-input>
        <el-input class="s_input" placeholder="请输入订单编号" suffix-icon="el-icon-search" v-model="orderCode" clearable
          @change="onSearch"></el-input>
        <el-select class="s_input" v-model="projectType" placeholder="请选择项目类型" clearable @change="onSearch">
          <el-option v-for="item in projectTypeArr" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-date-picker v-model="formInline.time" @change="gettime" type="daterange" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期"
          style="border-radius: 10px;  margin-left: 20px; border: 1px solid #ccc" value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <!-- tab栏 -->
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部订单" name="null"></el-tab-pane>
        <el-tab-pane label="待到店" name="0"></el-tab-pane>
        <el-tab-pane label="已完成" name="1"></el-tab-pane>
        <el-tab-pane label="已失效" name="2"></el-tab-pane>
        <el-tab-pane label="已取消" name="3"></el-tab-pane>
      </el-tabs>
      <!-- 表格 -->
      <div class="g_table">
        <el-table max-height="540" :data="tableData">
          <el-table-column label="序号" min-width="60" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>

          <el-table-column prop="projectName" label="项目名称" show-overflow-tooltip min-width="180" align="center">
          </el-table-column>
          <el-table-column prop="orderCode" label="订单编号" show-overflow-tooltip min-width="180" align="center">
          </el-table-column>
          <el-table-column prop="projectType" label="项目类型" show-overflow-tooltip min-width="100" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.projectType == 1">服务项目</div>
              <div v-if="scope.row.projectType == 2">体验项目</div>
              <div v-if="scope.row.projectType == 3">套餐项目</div>
            </template>
          </el-table-column>
          <el-table-column prop="reservationTime" label="预约时间" min-width="180" align="center">
            <template slot-scope="scope">
              <div>{{ `${scope.row.reservationTime}` || '--' }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="reservationTime" label="预约到店时间" show-overflow-tooltip min-width="150" align="center">
            <template slot-scope="scope">
              <div>{{ `${scope.row.reservationTime} ${scope.row.startHour}-${scope.row.endHour}` || '--' }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="userCode" label="用户编号" show-overflow-tooltip min-width="120" align="center">
          </el-table-column>
          <el-table-column prop="status" label="订单状态" show-overflow-tooltip min-width="100" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.status == 0" style="color: red;">待到店</div>
              <div v-if="scope.row.status == 1">已完成</div>
              <div v-if="scope.row.status == 2">已失效</div>
              <div v-if="scope.row.status == 3">已取消</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="150" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="primary" size="small" @click="handleVerify(scope.row)"
                v-if="scope.row.status == 0">核销</el-button>
              <el-button type="primary" size="small" plain @click="handleCommand(scope.row)">查看订单</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
        layout="prev, pager, next, jumper, sizes, total" :total="totalCount">
      </el-pagination>
    </div>
    <!-- 核销弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false" :destroy-on-close="true">
      <!-- 订单核销 -->
      <div class="verify_code" v-if="dialogTitle == '订单核销'">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="200px" class="demo-ruleForm">
          <el-row>
            <el-form-item label="订单核销码：" prop="verifyCode">
              <el-input v-model="ruleForm.verifyCode" placeholder="请输入核销码"></el-input>
            </el-form-item>
          </el-row>
        </el-form>
      </div>

      <!-- 选择员工 -->
      <div class="dialog_employee" v-if="dialogTitle == '选择员工'">
        <div class="verify_code_order">
          <div class="order_info">
            <div>订单号：{{ order.orderCode }}</div>
            <div>用户姓名：{{ order.userName }}</div>
            <div>联系电话：{{ order.userPhone }}</div>
          </div>
          <div class="project">项目名称：{{ order.projectName }}</div>
        </div>
        <el-tabs v-model="departmentId" @tab-click="handleClickEmployeeTabs">
          <el-tab-pane v-for="(item, index) in staffDepartmentList" :key="index" :label="item.departmentName"
            :name="item.departmentId"></el-tab-pane>
        </el-tabs>
        <div class="employee_list" v-loading="employeeloading">
          <div class="employee_list_item" v-for="(item, index) in staffList" :key="index"
            :class="employeeId == item.employeeId ? 'employee_ac' : ''" @click="changeStaff(item)">
            <div class="icon">
              <i class="el-icon-success" v-if="employeeId == item.employeeId"></i>
              <i class="el-icon-circle-check" v-else></i>
            </div>
            <div class="avatar">
              <img :src="item.avatarUrl || require('@/assets/img/staff.png')" width="60" height="60" />
            </div>
            <div class="info">
              <div class="name overt">{{ item.employeeName }}</div>
              <div class="code overt">员工编号：{{ item.employeeCode }}</div>
              <div class="num">今日服务次数：{{ item.count }}次</div>
            </div>
          </div>
        </div>
        <el-pagination class="pg_input" background @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2" :current-page.sync="currentPage2" :page-size="pageSize2"
          :page-sizes="pageSizeArr2" layout="prev, pager, next, jumper, sizes, total"
          :total="totalItemsCount2"></el-pagination>
      </div>
      <span slot="footer" v-if="dialogTitle == '订单核销'">
        <el-button @click="cancelVerifyCode">取 消</el-button>
        <el-button type="primary" @click="confirmVerifyCode('ruleForm')" :loading="btnLoading">核 销</el-button>
      </span>
      <span slot="footer" v-if="dialogTitle == '选择员工'">
        <el-button @click="cancelEmployee">上一步</el-button>
        <el-button type="primary" @click="confirmEmployee" :loading="btnLoading">确 定</el-button>
      </span>

    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      // 表格数据
      tableData: [],
      startTime: '',//开始时间
      endTime: '',//结束时间
      formInline: {
        time: []
      },//日期区间
      activeName: 'null',
      // 项目类型
      projectTypeArr: [
        {
          value: '1',
          label: '服务项目'
        }, {
          value: '2',
          label: '体验项目'
        }, {
          value: '3',
          label: '套餐项目'
        },
      ],
      projectType: '',//项目类型
      orderCode: '',//订单编号
      projectName: '',//项目名称
      // 分页器
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50],
      totalCount: 0, // 总记录数据
      // 弹窗分页器
      // 员工分页
      currentPage2: 1, // 当前页码
      pageSize2: 9, // 每页显示的行数
      pageSizeArr2: [9, 18, 54], // 每页显示的行数(可选)
      totalItemsCount2: 0, // 总记录数（需要从后端获取）
      dialogTitle: "订单核销",
      btnLoading: false,//核销按钮
      dialogVisible: false,//核销弹窗
      departmentId: "0",
      employeeId: "",
      employeeName: "",
      order: {},
      staffList: [],
      staffDepartmentList: [],//员工部门
      ruleForm: {
        verifyCode: "",//核销码
      },
      id: '',//核销时使用的订单id
      rules: {
        verifyCode: [
          { required: true, message: "请输入核销码", trigger: "blur" },
          { pattern: /^\d+$/, message: "请输入数字", trigger: "change" },
        ],
      },
    }
  },
  created() {
    this.getRequest()//请求数据
  },
  methods: {
    handleClick(tab) {
      const { name } = tab
      if (name == "null") {
        this.status = ''
      } else {
        this.status = name
      }
      this.getRequest()
    },
    // 请求
    getRequest() {
      this.loading = true;
      this.$axios.get(this.$api.reserveOrderList, {
        params: {
          storeId: this.$store.state.userInfo.bizId,//门店ID
          projectType: this.projectType || null,//项目类型:1.正式项目,2.体验项目,3.套餐项目
          orderCode: this.orderCode || null,//订单编号
          projectName: this.projectName || null,//项目名称
          status: this.status == 'null' ? '' : this.status,//状态(0待核销，1:已完成；2已过期；3已取消)
          startTime: this.startTime || null,//开始时间
          endTime: this.endTime || null,//结束时间
          page: this.currentPage,
          pageSize: this.pageSize,
        }
      }).then((res) => {
        const { code, result } = res
        if (code == 100) {
          this.totalCount = result.totalCount
          this.tableData = result.list || []
          this.loading = false;
        }
      }).catch((err) => {
        this.$message.error(err.desc)
        this.loading = false;
      })

    },
    // 时间区间搜索
    gettime() {
      this.startTime = this.formInline.time ? this.formInline.time[0] || "" : "";
      this.endTime = this.formInline.time ? this.formInline.time[1] || "" : "";
      this.getRequest()
    },
    // 核销
    handleVerify(row) {
      // console.log('核销', row);
      this.ruleForm.verifyCode = ""
      this.id = row.id
      this.dialogTitle = "订单核销"
      this.dialogVisible = true
    },
    // 跳转查看
    handleCommand(row) {
      this.$router.push({ name: 'reserveOrderDet', query: { id: row.id } })
    },
    // 员工列表
    getStaffList() {
      this.employeeloading = true
      this.$axios
        .get(this.$api.employeeInfoselectEmployee, {
          params: {
            parentId: this.departmentId == "0" ? "" : this.departmentId,
            storeId: this.$store.state.userInfo.bizId,
            page: this.currentPage2,
            pageSize: this.pageSize2,
          },
        })
        .then(res => {
          this.staffList = res.result.list
          this.totalItemsCount2 = res.result.totalCount
          this.employeeloading = false
        })
        .catch(err => {
          this.employeeloading = false
          this.$message.error(err.desc)
        })
    },
    // 员工部门
    getStaffDepartmentList() {
      this.$axios
        .get(this.$api.departmentInfoselectParentDepartment)
        .then(res => {
          let list = res.result.map(e => {
            return {
              ...e,
              departmentId: e.departmentId.toString(),
            }
          })
          list.unshift({ departmentId: "0", departmentName: "全部" })
          this.staffDepartmentList = list
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 切换员工部门
    handleClickEmployeeTabs() {
      this.staffList = []
      this.currentPage2 = 1
      this.getStaffList()
    },
    // 切换员工
    changeStaff(e) {
      this.employeeId = e.employeeId
      this.employeeName = e.employeeName
    },
    // 取消核销
    cancelVerifyCode() {
      // this.ruleForm.verifyCode = ""
      this.resetForm()
      this.dialogVisible = false
    },
    // 提交核销
    async confirmVerifyCode(formName) {
      this.btnLoading = true
      try {
        // 校验表单
        await new Promise((resolve, reject) => {
          this.$refs[formName].validate(valid => {
            if (!valid) {
              this.btnLoading = false
              return
            } else {
              resolve() // 校验成功
            }
          })
        })
        await this.$axios
          .get(this.$api.reserveOrderVerification,
            {
              params: {
                id: this.id,
                verifyCode: this.ruleForm.verifyCode,
                storeId: this.$store.state.userInfo.bizId,
              },
            }
          )
          .then(res => {
            const { code, result } = res
            if (code == 100) {
              this.getStaffList()
              this.getStaffDepartmentList()
              this.order = result
              this.dialogTitle = "选择员工"
              this.btnLoading = false

            }
          })
          .catch(err => {
            this.btnLoading = false
            this.$message.error(err.desc)
          })
      } catch (err) {
        // this.$message.error(err.desc)
        this.btnLoading = false
      }
    },
    // 表单重置
    resetForm() {
      this.ruleForm.verifyCode = ""
      this.$refs.ruleForm.resetFields()
    },
    // 取消员工，返回上一步
    cancelEmployee() {
      this.employeeId = ""
      this.employeeName = ""
      this.order = {}
      this.dialogTitle = "订单核销"
    },
    // 确定员工
    confirmEmployee() {
      this.btnLoading = true
      this.$axios
        .post(this.$api.technicianConfirmation, {
          verifyCode: this.ruleForm.verifyCode,
          storeId: this.$store.state.userInfo.bizId,
          employeeId: this.employeeId,
          projectOrderItemId: this.order.projectOrderItemId,
        })
        .then(res => {
          const { code } = res
          if (code == 100) {
            this.btnLoading = false
            this.dialogVisible = false
            this.$message.success("核销成功")
            this.onSearch() // 重置校验
            // this.$refs.ruleForm.resetFields() // 重置校验
          }
        })
        .catch(err => {
          this.btnLoading = false
          this.$message.error(err.desc)
        })
    },

    // 清空
    clearData() {
      this.tableData = [];
      this.currentPage = 1;
    },
    // 搜索
    onSearch() {
      this.clearData();
      this.getRequest();
    },
    handleSizeChange(e) {
      this.pageSize = e
      this.getRequest()
    },
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getRequest()
    },
    // 切换每页显示的条数 - 员工
    handleSizeChange2(e) {
      this.staffList = []
      this.pageSize2 = e
      this.getStaffList()
    },
    // 换页 - 员工
    handleCurrentChange2(e) {
      this.staffList = []
      this.currentPage2 = e
      this.getStaffList()
    },
  },
}
</script>

<style scoped lang='scss'>
.content {
  .el-date-editor {
    margin-left: 10px !important;
  }

  .header-btn {
    margin-left: 10px;
  }
}

// 核销弹窗
.dialog_employee {
  .verify_code_order {
    display: flex;
    flex-direction: column;
    color: #707070;
    padding: 15px;
    margin-bottom: 20px;
    background: rgba(3, 16, 14, 0.05);
    border-radius: 10px 10px 10px 10px;

    .order_info {
      display: flex;
      justify-content: space-between;
      margin-bottom: 15px;
    }
  }

  .employee_list {
    display: flex;
    flex-wrap: wrap;

    .employee_list_item {
      display: flex;
      align-items: center;
      width: 295px;
      height: 95px;
      padding: 10px;
      margin-right: 15px;
      margin-bottom: 15px;
      font-size: 14px;
      color: #707070;
      background: #fff;
      box-shadow: 0px 3px 30px 1px rgba(38, 30, 3, 0.04);
      border-radius: 6px 6px 6px 6px;
      border: 1px solid #e8e8e8;
      box-sizing: border-box;
      cursor: pointer;

      .icon {
        font-size: 20px;
      }

      .avatar img {
        border-radius: 50%;
        margin: 0 10px;
      }

      .info {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        height: 100%;

        .name {
          color: #0f1c40;
          font-weight: bold;
        }

        .overt {
          display: -webkit-box;
          word-break: break-all;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .employee_ac {
      color: $themes;
      border-color: $themes;
    }
  }
}

// 操作下拉框内容
.el-dropdown-link {
  cursor: pointer;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.el-date-editor,
.el-range-editor,
.el-input__inner,
.el-date-editor--daterange {
  margin-left: 0px !important;
}

.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 250px;
}
</style>
